<div class="aupris_main">

    <h4 style="text-align:center;">{{languageData['Popups']['Var_no_invoice']|| 'Rechnung nicht verfügbar'}}</h4>
    <button class="au-btn btn-default borderCss" type="button"
        [ngStyle]="{background: 'var(--primaryColour)',color: 'var(--primaryTextColour)'}"
        (click)="onclick()">{{languageData['Popups']['Var_schlieben']|| 'Schließen'}}</button>
</div>